module.exports = __webpack_public_path__ + "images/9f74f2761e1d7e9f28b626475da19945-ab-map.png";